var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.329 16.0005C12.262 16.0005 12.193 15.9975 12.124 15.9905C11.244 15.9035 10.554 15.2825 10.364 14.4075L7.681 2.01555L4.918 8.39755C4.759 8.76355 4.398 9.00055 4 9.00055H1C0.447 9.00055 0 8.55255 0 8.00055C0 7.44755 0.447 7.00055 1 7.00055H3.344L5.85 1.21155C6.205 0.395547 6.987 -0.0794532 7.876 0.00954679C8.756 0.0965468 9.446 0.717547 9.636 1.59255L12.319 13.9845L15.082 7.60255C15.241 7.23655 15.601 7.00055 16 7.00055H19C19.553 7.00055 20 7.44755 20 8.00055C20 8.55255 19.553 9.00055 19 9.00055H16.656L14.15 14.7885C13.823 15.5415 13.122 16.0005 12.329 16.0005Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.1b5f2520cfcbed336900b0906f31ff02.svg";
export { ForwardRef as ReactComponent };